import { Divider } from '@customink/pigment-react';

export function OrDivider() {
    return (
        <Divider>
            <span style={{ padding: '0 55px' }}>OR</span>
        </Divider>
    );
}
